import React from 'react'
import Navbar from '../../components/navbar/Navbar'

const Advice = () => {
  return (
    <>
      <Navbar showLinks={true} />
      <div className="pages-container">
        <h1 className="pages-content">Advice Coming Soon!</h1>
      </div>
    </>
  )
}

export default Advice